import React from "react";
import PageHeader from "@/components/PageHeader";
import ItemsTable from "@/components/ItemsTable";
import { useDropdownOptions } from "@/hooks/useDropdownOptions";

export default function Agenda() {
  const { owners, priorities, taskStatuses } = useDropdownOptions();

  const columns = [
    { key: "top_priority_rank", label: "Top 3", type: "select", width: 90,
      options: [{ label: "—", value: "0" }, { label: "1", value: "1" }, { label: "2", value: "2" }, { label: "3", value: "3" }] },
    { key: "scheduled_time", label: "Time", type: "time", width: 110 },
    { key: "title", label: "Task", type: "text", placeholder: "What needs to happen?", required: true },
    { key: "owner", label: "Owner", type: "select", options: owners, width: 150 },
    { key: "priority", label: "Priority", type: "select", options: priorities, width: 130 },
    { key: "status", label: "Status", type: "select", options: taskStatuses, width: 160 },
    { key: "date", label: "Date", type: "date", width: 150 },
    { key: "follow_up_date", label: "Follow-up", type: "date", width: 150 },
    { key: "notes", label: "Notes", type: "text", placeholder: "Notes" },
    { key: "completed", label: "Done", type: "checkbox", width: 80 },
  ];

  return (
    <div className="max-w-[1600px] mx-auto px-8 py-10">
      <PageHeader
        eyebrow="Daily Agenda"
        title="Today's Plan"
        description="Set the top three priorities, schedule the day, and mark items complete as you go."
      />
      <ItemsTable
        endpoint="tasks"
        columns={columns}
        defaultItem={{ title: "", owner: "", priority: "Normal", status: "not started", completed: false, notes: "" }}
        testIdPrefix="agenda"
        emptyLabel="No tasks yet — add your first one above."
      />
    </div>
  );
}
